import { createContext, useContext } from 'solid-js';

const DependencyInjectionContext = createContext(null);
function useDependency(token) {
  const container = useContext(DependencyInjectionContext);
  return container.get(token);
}
function useDependencies(token, options) {
  const container = useContext(DependencyInjectionContext);
  const {
    expectEmpty
  } = Object.assign({
    expectEmpty: false
  }, options);
  if (!expectEmpty) {
    return container.getAll(token);
  }
  let results = [];
  try {
    results = container.getAll(token);
  } catch {
  }
  return results;
}

export { DependencyInjectionContext, useDependencies, useDependency };
//# sourceMappingURL=index.es.js.map
